import React, { useCallback, useEffect, useState } from "react";
import { Modal, Collapse, Spin, Icon } from "antd";
import { use } from "react";
import { EA, REVIEWADMIN } from "../../../../utils/Constants";
import { FS_WEEKLY_DASHBOARD, RS_WEEKLY_DASHBOARD } from "../../../../utils/Api_enums";
import axios from "axios";
import moment from "moment";
import F from '../../../../Functions'

const { Panel } = Collapse;

const WeeklyStatModal = ({ visible, onClose, data, role }) => {
  const [loading, setLoading] = useState(false);
  const [weeklyData, setWeeklyData] = useState({});

  useEffect(() => {
    if (visible && data) {
      fetchWeeklyStatsReport(data);
    }
  }, [visible, data, role]);



  const fetchWeeklyStatsReport = (async (rowData) => {
    console.log("Fetching weekly stats for:", rowData);
    const monthNumber = moment(rowData.month, "MMMM").month() + 1;
    try {
      setLoading(true);
      let endpoint = "";
      if (role === REVIEWADMIN) {
        endpoint = RS_WEEKLY_DASHBOARD;
      } else if (role === EA) {
        endpoint = FS_WEEKLY_DASHBOARD;
      }

      if (!endpoint) return;

      const response = await axios.get(endpoint, {
        params: {
          agency_id: rowData.agency_id,
          // scheduler_email: rowData.scheduler_email
          scheduler_id: rowData.scheduler_id,
          month: monthNumber,
          type_of_call: rowData.type_of_call
        }
      });

      setWeeklyData(response.data.data);

    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  });

  const cardStyle = {
    flex: "1 1 120px",
    padding: "15px",
    borderRadius: "8px",
    background: "white",
    textAlign: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  };

  const labelStyle = {
    fontSize: "14px",
    color: "#888",
    marginBottom: "8px",
    textTransform: "uppercase"
  };

  const iconStyle = {
    fontSize: "20px",
    marginBottom: "8px",
    color: "#1890ff"
  };

  return (
    <div>
      {
        loading && (
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}>
            <Spin tip="Loading ..." />
          </div>
        )}
      <Modal
        title={
          <div>
            <div style={{ fontSize: 18 }}>
              <span>
                <span style={{ fontWeight: 600 }}>{data && data.scheduler}</span>
              </span>
            </div>

            {/* {data && (data.carrier || data.month) ? (
              <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
                {[data.carrier, data.month]
                  .filter(function (item) {
                    return item;
                  })
                  .join(" - ")}
              </div>
            ) : null} */}


            {data && data.month && (
              <span style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
                <span style={{ fontWeight: 'bold' }}>Month:</span> {data.month}
              </span>
            )}


            {data && (data.carrier) ? (
              <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
                {data.carrier && (
                  <span>
                    <span style={{ fontWeight: 'bold' }}>Carrier:</span> {data.carrier}
                  </span>
                )}
                {/* {data.carrier && data.month && " - "} */}
                {/* {data.month && (
                  <span>
                    <span style={{ textDecoration: "underline" }}>Month:</span> {data.month}
                  </span>
                )} */}
              </div>
            ) : null}

            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
              {data && data.agency_name && (
                <span>
                  <span style={{ fontWeight: 'bold' }}>Agency:</span> {data.agency_name}
                </span>
              )}
            </div>

          </div>
        }
        visible={visible}
        onCancel={onClose}
        footer={null}
        width={1000}
        centered
      >

        <Collapse accordion>
          {Object.entries(weeklyData).map(([weekName, days], index) => (
            <Panel header={weekName} key={index}>

              {days.map((day) => (
                <div key={day.date} style={{ marginBottom: "20px" }}>

                  <h4>{day.label}</h4>

                  <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>

                    {/* Call Today */}
                    <div style={cardStyle}>
                      <Icon type="phone" style={iconStyle} />
                      <p style={labelStyle}>Call Today</p>
                      <h3>{day.call_today ? "Yes" : "No"}</h3>
                    </div>


                    {/* Last Call */}
                    <div style={cardStyle}>
                      <Icon type="clock-circle" style={iconStyle} />
                      <p style={labelStyle}>Oldest Call</p>
                      <h3>{F.formatToLocal(day.oldest_call_time) || "—"}</h3>
                    </div>


                    {/* Last Call */}
                    <div style={cardStyle}>
                      <Icon type="clock-circle" style={iconStyle} />
                      <p style={labelStyle}>Last Call</p>
                      <h3>{F.formatToLocal(day.last_call_time) || "—"}</h3>
                    </div>

                    {/* Calls Made */}
                    <div style={cardStyle}>
                      <Icon type="customer-service" style={iconStyle} />
                      <p style={labelStyle}>Calls Made</p>
                      <h3>{day.total_calls}</h3>
                    </div>

                    {/* Appointments */}
                    <div style={cardStyle}>
                      <Icon type="calendar" style={iconStyle} />
                      <p style={labelStyle}>Appointments</p>
                      <h3>{day.total_appointments}</h3>
                    </div>

                  </div>
                </div>
              ))}

            </Panel>
          ))}
        </Collapse>
        {/* <Collapse accordion>
          {weeks.map((week, index) => (
          <Panel header={week} key={index + 1}>
            <p>{week} Data Here</p>
          </Panel>
        ))}
        </Collapse> */}
      </Modal>
    </div>
  );
};

export default WeeklyStatModal;


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/WeeklyStatModal.js